<template>
  <q-dialog
    v-model="dialog"
    persistent
    style="max-width: 500px"
    class="custom-font text-uppercase"
  >
    <q-card style="width:500px" class="pragma-black">
      <q-form @submit.prevent="agregarEditarItem()">
        <q-card-section class="q-pa-none">
          <q-toolbar class="bg-pragma text-white shadow-2 rounded-borders">
            <q-btn flat label="Información del ítem" />
            <q-space />
            <q-btn
              v-if="!form.edit"
              icon="clear"
              @click="closeDialog()"
              flat
            ></q-btn>
            <q-btn
              v-if="form.edit"
              icon="clear"
              @click="closeDialogEdit()"
              flat
            ></q-btn>
          </q-toolbar>
        </q-card-section>
        <q-card-section>
          <div class="row q-gutter-y-sm">
            <div class="col-xs-12">
              <q-input
                type="number"
                v-model="form.cantidad"
                label="Cantidad"
                :rules="[v => !!v || 'Requerido', v => v >= 0 || 'La cantidad debe ser mayor a 0', , v => v < 99999999 || 'La cantidad es muy grande']"
                dense
                outlined
                label-color="grey"
                dark
                disable
              ></q-input>
            </div>
            <div class="col-xs-12">
              <q-select
                v-model="form.unidad"
                :options="unidades"
                option-label="descripcion"
                option-value="id"
                :rules="[v => !!v || 'Requerido']"
                dense
                outlined
                label-color="grey"
                dark
                label="Unidad"
                options-dense
                disable
              ></q-select>
            </div>
            <!-- Tipo de compra dinámico -->
            <div class="col-xs-12">
              <q-select
                v-model="form.tipo_compra"
                :options="tipo_compra_tipo_1"
                option-label="descripcion"
                option-value="id"
                :rules="[v => !!v || 'Requerido']"
                dense
                outlined
                label-color="grey"
                dark
                label="Tipo compra"
                options-dense
                v-if="props.modalidad_id === 1 || props.modalidad_id === 2"
              ></q-select>
              <q-select
                v-model="form.tipo_compra"
                :options="tipo_compra_tipo_2"
                option-label="descripcion"
                option-value="id"
                :rules="[v => !!v || 'Requerido']"
                dense
                outlined
                label-color="grey"
                dark
                label="Tipo compra"
                options-dense
                v-if="props.modalidad_id === 3 || props.modalidad_id === 4"
              ></q-select>
            </div>
            <div class="col-xs-12">
              <q-input
                v-model="form.detalle"
                label="Detalle"
                class="iu"
                :rules="[v => !!v || 'Requerido']"
                dense
                outlined
                label-color="grey"
                dark
                disable
              ></q-input>
            </div>
            <div class="col-xs-12" v-if="props.modalidad_id == 3 || props.modalidad_id == 4">
              <q-input
                v-model="form.nrofactura"
                type="number"
                label="Nro. Factura / Recibo"
                :rules="[v => !!v || 'Requerido', v => v < 999999999999 || 'La cantidad es muy grande']"
                dense
                outlined
                label-color="grey"
                dark
              ></q-input>
            </div>
            <div class="col-xs-12" v-if="props.modalidad_id == 3 || props.modalidad_id == 4">
              <q-input
                v-model="form.fechafactura"
                label="Fecha Factura / Recibo"
                dense
                outlined
                label-color="grey"
                dark
                :rules="[v => !!v || 'Requerido']"
                readonly>
                <template v-slot:append>
                  <q-icon name="event" class="cursor-pointer">
                    <q-popup-proxy ref="qDateProxy" cover transition-show="scale" transition-hide="scale">
                      <q-date v-model="form.fechafactura" mask="DD/MM/YYYY" color="blue-grey" dark>
                        <div class="row items-center justify-end">
                          <q-btn v-close-popup label="Aceptar" color="white" flat />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
            </div>
            <div class="col-xs-12" v-if="props.modalidad_id == 3 || props.modalidad_id == 4">
              <q-input
                v-model="form.itemproyecto"
                label="Proyecto"
                class="iu"
                :rules="[v => !!v || 'Requerido']"
                dense
                outlined
                label-color="grey"
                dark
              ></q-input>
            </div>
            <div class="col-xs-12" v-if="props.modalidad_id == 3 || props.modalidad_id == 4">
              <q-input
                v-model="form.itemproveedor"
                class="iu"
                label="Proveedor"
                :rules="[v => !!v || 'Requerido']"
                dense
                outlined
                label-color="grey"
                dark
              ></q-input>
            </div>
            <div class="col-xs-12" v-if="props.modalidad_id == 3 || props.modalidad_id == 4">
              <q-select
                v-model="form.itemtipo"
                :options="['FACTURA', 'RECIBO']"
                label="Tipo"
                :rules="[v => !!v || 'Requerido']"
                dense
                outlined
                label-color="grey"
                dark
                emit-value
                map-options
              ></q-select>
            </div>
            <div class="col-xs-12">
              <q-input
                type="number"
                v-model="form.costo"
                label="Precio unitario"
                :rules="[v => !!v || 'Requerido', v => v >= 0 || 'El precio unitario debe ser mayor a 0', v => v < 9999999999 || 'La cantidad es muy grande']"
                dense
                outlined
                label-color="grey"
                dark
                step="0.01"
                disable
              ></q-input>
            </div>
            <div class="col-xs-12">
              <q-input
                v-model="form.subtotal"
                label="Sub. total"
                dense
                outlined
                label-color="grey"
                dark
                disable
                :rules="[v => v !== 0 || 'El subtotal no puede ser igual a 0']"
              ></q-input>
            </div>
          </div>
        </q-card-section>
        <q-card-actions>
          <div class="row q-pa-sm full-width items-center text-center">
            <div class="col-xs-6 q-pr-sm">
              <q-btn
                v-if="!form.edit"
                label="Cancelar"
                color="negative"
                @click="closeDialog()"
                icon="clear"
                class="full-width"
              ></q-btn>
              <q-btn
                v-if="form.edit"
                label="Cancelar"
                color="negative"
                @click="closeDialogEdit()"
                icon="clear"
                class="full-width"
              ></q-btn>
            </div>
            <div class="col-xs-6 q-pl-sm">
              <q-btn
                type="submit"
                label="Guardar"
                color="positive"
                icon="save"
                class="full-width"
              ></q-btn>
            </div>
          </div>
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import {inject, ref} from 'vue'
import axios from 'axios'
import moment from 'moment'

export default {
  props: ['modalidad_id'],
  setup (props) {
    // Variables reactivas y no reactivas
    const bus = inject('bus')
    const dialog = ref(false)
    const form = ref({
      cantidad: '',
      unidad: '',
      tipo_compra: '',
      detalle: '',
      nrofactura: '',
      fechafactura: '',
      itemproyecto: '',
      itemproveedor: '',
      itemtipo: 'FACTURA',
      precio_unitario: '',
      sub_total: 0,
      edit: false
    })

    const unidades = ref([])
    const itemsTipos = ref([])
    const form_old = ref({})
    const tipo_compra_tipo_1 = ref([])
    const tipo_compra_tipo_2 = ref([])
    const subtotal_format = ref(0)

    // Métodos y funciones del componente
    const getUnidades = async () => {
      let res = await axios.get('unidad')
      unidades.value = res.data
    }

    const getItemsTipos = async () => {
      let res = await axios.get('item-tipo')
      itemsTipos.value = res.data
      // Armado de arrays de tipos de compra
      res.data.forEach(item => {
        if (item.id == 1 ||
            item.id == 7 ||
            item.id == 2 ||
            item.id == 4 ||
            item.id == 3
            ) {
          tipo_compra_tipo_1.value.push(item)
        }
        if (item.id == 2 ||
            item.id == 4 ||
            item.id == 3
            ) {
          tipo_compra_tipo_2.value.push(item)
        }
      })
    }

    const getSubTotal = () => {
      if (form.value.cantidad !== null && form.value.precio_unitario !== null && form.value.cantidad > 0 && form.value.precio_unitario > 0) {
        form.value.sub_total = form.value.cantidad * form.value.precio_unitario
        subtotal_format.value = form.value.sub_total.toFixed(2)
      } else {
        form.value.sub_total = 0
      }
    }

    const agregarEditarItem = () => {
      bus.emit('actualizarItemAprobador', form.value)
      closeDialog()
    }

    const closeDialog = () => {
      form.value = {}
      subtotal_format.value = 0
      dialog.value = false
    }

    const closeDialogEdit = () => {
      bus.emit('agregarItem', form_old.value)
      form.value = {}
      form_old.value = {}
      dialog.value = false
    }

    // Creación del componente
    getUnidades()
    getItemsTipos()
    bus.on('openDialogEditarItem', (item) => {
      const obj = {
        cantidad: item.cantidad,
        unidad: item.unidad,
        tipo_compra: item.tipo_compra,
        detalle: item.detalle,
        nrofactura: item.nrofactura,
        fechafactura: moment(item.fechafactura, 'YYYY-MM-DD').format('DD/MM/YYYY'),
        itemproyecto: item.itemproyecto,
        itemproveedor: item.itemproveedor,
        itemtipo: item.itemtipo,
        precio_unitario: item.precio_unitario,
        sub_total: item.sub_total,
      }
      form_old.value = obj
      form.value = {
        ...item,
        fechafactura: item.fechafactura ? moment(item.fechafactura, 'YYYY-MM-DD').format('DD/MM/YYYY') : '',
      }
      subtotal_format.value = item.sub_total
      dialog.value = true
    })

    // Retorno de variables al template
    return {
      dialog,
      closeDialog,
      form,
      unidades,
      itemsTipos,
      getSubTotal,
      agregarEditarItem,
      closeDialogEdit,
      props,
      tipo_compra_tipo_1,
      tipo_compra_tipo_2,
      subtotal_format
    }
  }
}
</script>

<style>

</style>